import { render, staticRenderFns } from "./modal-get-wallpaper.vue?vue&type=template&id=1661ec66&scoped=true&"
import script from "./modal-get-wallpaper.vue?vue&type=script&lang=js&"
export * from "./modal-get-wallpaper.vue?vue&type=script&lang=js&"
import style0 from "./modal-get-wallpaper.vue?vue&type=style&index=0&id=1661ec66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1661ec66",
  null
  
)

export default component.exports